import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router/composables';

import { Heading } from '@warrenbrasil/nebraska-web';

import { CardCounter } from '@/modules/common/components/cards/CardCounter';

import {
  IAccountDataCards,
  EButtonType,
  getButtons
} from '@/modules/home/services/consolidation';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCards',
  emits: ['open-register-panel'],
  setup(__props, { emit }) {



const router = useRouter();
const cardsData = ref<IAccountDataCards | null>(null);

const fetchButtons = async () => {
  try {
    const data = await getButtons();
    cardsData.value = data;
  } catch (error) {
    console.log(error);
  }
};

onBeforeMount(fetchButtons);

const handleClick = (type: EButtonType) => {
  switch (type) {
    case EButtonType.IN_PORTABILITY:
      window.open('/products/#/portability', '_self');
      break;
    case EButtonType.OUT_PORTABILITY:
      router.push({ name: 'portabilityRequests' });
      break;
    case EButtonType.SUGGESTIONS:
      router.push({ name: 'investmentSuggestions' });
      break;
    case EButtonType.REGISTER:
      emit('open-register-panel');
      break;
    default:
      break;
  }
};

return { __sfc: true,emit, router, cardsData, fetchButtons, handleClick, Heading, CardCounter }
}

})